import { t } from 'i18next'

import { QuantityTableProps } from './type'
export const CART_ITEM_DETAIL_TABLE_LABEL: {
  [key in keyof QuantityTableProps['salesTypeQuantity']]: string
} = {
  salesTypeName: t('order.history.fields.salesTypeName'),
  quantity: t('order.history.fields.quantity'),
  note: t('order.history.fields.note'),
  price: t('order.history.fields.price'),
  summaryPrice: t('order.history.fields.summaryPrice'),
} as const

export const CART_ITEM_DETAIL_TABLE_KEYS: (keyof typeof CART_ITEM_DETAIL_TABLE_LABEL)[] =
  ['salesTypeName', 'quantity', 'note', 'price', 'summaryPrice']
